
import { DatePipe } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  Aviso,
  BaseResourceListComponent, Coluna,
  Filtro, FormatoExportacao, GlobalService, LoginContabil
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { AvisoService } from '../service/aviso.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'lib-aviso-list',
  templateUrl: './aviso-list.component.html'
})
export class AvisoListComponent extends BaseResourceListComponent<Aviso, LoginContabil> {

  /**
   * Declaração de variáveis
   */
  public ptBR: any;
  public datepipe: DatePipe;

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private route: ActivatedRoute,
    private globalService: GlobalService,
    private avisoService: AvisoService) {
    super(avisoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected podeAlterar(item: Aviso): boolean {
    return true;
  }

  protected relations(): string {
    return 'orgao,setores';
  }

  protected condicoesGrid(): {} {
    const parametros = {
      'orgao.id': this.login.orgao.id
    };

    this.datepipe = new DatePipe('pt');
    return parametros;
  }

  protected ordenacaoGrid(): string[] {
    return [];
  }

  protected filtrosGrid(): Filtro {
    return {
    };
  }

  public beforeInit(): void {
    this.usarFiltroPersonalizado = true;
    this.usarExtendido = false;
    this.ptBR = this.globalService.obterDataBR();
    this.datepipe = new DatePipe('pt');
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: Aviso): Observable<Aviso> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Data Início', coluna: 'data_inicio', alignment: 'center' },
      { titulo: 'Data Fim', coluna: 'data_fim', alignment: 'center' },
      { titulo: 'Mensagem', coluna: 'mensagem' },
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'setores.setor,emissor,orgao';
    this.avisoService
      .filtrar(1,
        -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        retorno => {
          let lista = []
          retorno.content.forEach(item => {
            lista.push({
              data_inicio: item.data_inicio,
              data_fim: item.data_fim,
              mensagem: item.mensagem,
              // setores: item.setores.map(setor => setor.setor.nome).join(', '),
              // emissor: item.emissor.nome
            })
          })
          if (formato === 'pdf') {
            this.imprimir('AVISOS',
              this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'landscape',
              'AVISOS', ['15%', '15%', '70%'], lista);
          } else {
            this.exportar(formato, lista);
          }
        },
      );
  }

  public obterColunasFiltroPersonalizado(): Coluna[] {
    const retorno: Coluna[] = [];
    retorno.push({
      titulo: 'Data Início', coluna: 'data_inicio', alignment: 'center', tipo: 'Date', padrao: true
    });
    retorno.push({ titulo: 'Data Fim', coluna: 'data_fim', tipo: 'Date', alignment: 'center', padrao: false });
    retorno.push({ titulo: 'Mensagem', coluna: 'mensagem', tipo: 'String', padrao: true });
    retorno.push({ titulo: 'Nome do Setor', coluna: 'setores.setor.nome', tipo: 'String', padrao: true });
    retorno.push({ titulo: 'Nome do Usuário', coluna: 'emissor.nome', tipo: 'String', padrao: true });
    return retorno;
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================
}